import { createClient } from '../clientConfiguration';

export const onboardingApiClient = createClient({
  baseURL: '/rest-api/onboarding',
});
